/* eslint no-param-reassign: 0 */
import { cloneDeep } from 'lodash';
import Vue from 'vue';

export const addValidationErrorsToState = (state) => {
  const state2 = cloneDeep(state);
  state2.entities.validationErrors = [];
  state2.entities.duplicateValidationErrors = [];
  return state2;
};

/**
 * * The ValidationErrorsMixin can be used by Vuex modules that need
 * to keep validation errors in the store.
 *
 * Note that this mixin is intended to be used in a module that extends the
 * CollectionModule class because it expects actions, getters, and mutations
 * defined there to be present.
 */
export default {

  actions: {

    /**
     * @description Adds duplicate error  to duplicateValidationErrors array.
     */
    addDuplicateValidationError({ commit, state }, { selectedItemId, fieldName }) {
      const errorObject = { selectedItemId, fieldName };
      const errorIndex = state.entities.duplicateValidationErrors
        .findIndex(i => i.selectedItemId === selectedItemId && i.fieldName === fieldName);
      if (errorIndex === -1) {
        commit('ADD_DUPLICATE_VALIDATION_ERROR', errorObject);
      }
    },

    /**
     * @description Adds error to validationErrors array if a duplicate doesn't exist.
     */
    addValidationError({ commit, state }, { selectedItemId, fieldName }) {
      const errorObject = { selectedItemId, fieldName };
      const errorIndex = state.entities.validationErrors
        .findIndex(i => i.selectedItemId === selectedItemId && i.fieldName === fieldName);
      if (errorIndex === -1) {
        commit('ADD_VALIDATION_ERROR', errorObject);
      }
    },

    /**
     * @description Removes duplicate error from validationErrors array
     * if the error passed in is found.
     */
    removeDuplicateValidationError({ commit, state }, { selectedItemId, fieldName }) {
      const errorIndex = state.entities.duplicateValidationErrors
        .findIndex(i => i.selectedItemId === selectedItemId && i.fieldName === fieldName);
      if (errorIndex > -1) {
        commit('REMOVE_DUPLICATE_VALIDATION_ERROR', errorIndex);
      }
    },

    /**
     * @description Removes error from validationErrors array if the error passed in is found.
     */
    removeValidationError({ commit, state }, { selectedItemId, fieldName }) {
      const errorIndex = state.entities.validationErrors
        .findIndex(i => i.selectedItemId === selectedItemId && i.fieldName === fieldName);
      if (errorIndex > -1) {
        commit('REMOVE_VALIDATION_ERROR', errorIndex);
      }
    },

    /**
     * @description Reset validationErrors array.
     */
    resetValidationErrors({ commit }) {
      commit('RESET_VALIDATION_ERRORS');
    },

  },

  getters: {
    getValidationErrors(state) {
      return state.entities.validationErrors;
    },
    getValidationErrorCount(state) {
      return state.entities.validationErrors.length;
    },
    getDuplicateValidationErrors(state) {
      return state.entities.duplicateValidationErrors;
    },
    getDuplicateValidationErrorCount(state) {
      return state.entities.duplicateValidationErrors.length;
    },
  },

  mutations: {
    ADD_DUPLICATE_VALIDATION_ERROR(state, error) {
      state.entities.duplicateValidationErrors.push(error);
    },

    ADD_VALIDATION_ERROR(state, error) {
      state.entities.validationErrors.push(error);
    },
    REMOVE_DUPLICATE_VALIDATION_ERROR(state, index) {
      state.entities.duplicateValidationErrors.splice(index, 1);
    },
    REMOVE_VALIDATION_ERROR(state, index) {
      state.entities.validationErrors.splice(index, 1);
    },

    RESET_VALIDATION_ERRORS(state) {
      Vue.set(state.entities, 'duplicateValidationErrors', []);
      Vue.set(state.entities, 'validationErrors', []);
    },
  },
};
